import React, { createContext, useContext, useState } from 'react';

const traducciones = {
    es: {
        nav: {
            inicio: 'Inicio', vender: 'Vender', mesas: 'Mesas', pedidos: 'Pedidos',
            inventario: 'Inventario', menu: 'Menú', cartaQr: 'Carta QR',
            reportes: 'Reportes', ajustes: 'Ajustes',
        },
        usuario: {
            cambiarPassword: 'Cambiar contraseña', cerrarSesion: 'Cerrar sesión',
            verOtrosPlanes: 'Ver otros planes', confirmarSalir: '¿Estás seguro que deseas cerrar sesión?',
        },
        carta: {
            cargando: 'Cargando menú...',
            todos: 'Todos',
            verCarrito: 'VER CARRITO',
            enviarCocina: 'ENVIAR A COCINA',
            tuSeleccion: 'Tu Selección',
            tuPedidoMesa: 'Tu Pedido en Mesa',
            cantidad: 'Cantidad',
            personalizacion: 'Personalización',
            valorProductos: 'VALOR PRODUCTOS',
            valor: 'VALOR',
            continuarPago: 'CONTINUAR AL PAGO',
            agregarMas: 'Agregar más productos',
            enviandoCocina: '⏳ ENVIANDO...',
            mensajeCocina: 'Al enviar, tu pedido irá directo a cocina 🍳',
            datosPedido: 'Datos de tu Pedido 📝',
            validarWhatsapp: 'Validar WhatsApp 📱',
            delivery: 'Delivery',
            retiroLocal: 'Retiro Local',
            nombreCompleto: 'Nombre completo',
            telefono: 'Teléfono (Ej: 9 1234 5678)',
            nota: 'Alguna nota (Sin cebolla, etc.)',
            metodoPago: 'Método de Pago',
            resumenCuenta: 'Resumen de Cuenta',
            valorProductosLabel: 'Valor Productos',
            costoEnvio: 'Costo Envío',
            gratis: 'Gratis ($0)',
            totalPagar: 'TOTAL A PAGAR',
            procesando: 'PROCESANDO...',
            validarCodigo: 'VALIDAR CÓDIGO',
            enviarPedido: 'ENVIAR PEDIDO POR',
            cerrar: 'Cerrar',
            pedidoCancelado: 'PEDIDO CANCELADO',
            canceladoMsg: 'Lo sentimos, el local ha cancelado tu pedido.',
            stockMsg: 'Puede ser por falta de stock o fuera de rango.',
            entendidoVolver: 'ENTENDIDO, VOLVER AL MENÚ',
            hacerNuevoPedido: '✨ HACER NUEVO PEDIDO',
            cerrarVerMenu: 'CERRAR Y VER MENÚ',
            tuPedido: 'TU PEDIDO',
            total: 'TOTAL',
            verDetalle: '🛒 VER DETALLE DEL PEDIDO',
            ocultarDetalle: '🛒 OCULTAR DETALLE',
            cargandoMapa: 'Cargando mapa...',
            fueraDeRango: '❌ Lo sentimos, esta ubicación está fuera de nuestra zona de reparto.',
            verificado: '✅ Verificado',
            tocar: 'Toca el',
            paraVerificar: 'para verificar',
            esperandoSms: '📱 Validación por SMS',
            enviarSms: '📨 ENVIAR CÓDIGO SMS',
            enviandoSms: 'ENVIANDO...',
            codigoValido: 'Código válido por 5 minutos',
        },
    },
    en: {
        nav: {
            inicio: 'Home', vender: 'Sell', mesas: 'Tables', pedidos: 'Orders',
            inventario: 'Inventory', menu: 'Menu', cartaQr: 'QR Menu',
            reportes: 'Reports', ajustes: 'Settings',
        },
        usuario: {
            cambiarPassword: 'Change password', cerrarSesion: 'Log out',
            verOtrosPlanes: 'View other plans', confirmarSalir: 'Are you sure you want to log out?',
        },
        carta: {
            cargando: 'Loading menu...',
            todos: 'All',
            verCarrito: 'VIEW CART',
            enviarCocina: 'SEND TO KITCHEN',
            tuSeleccion: 'Your Selection',
            tuPedidoMesa: 'Your Table Order',
            cantidad: 'Quantity',
            personalizacion: 'Customization',
            valorProductos: 'PRODUCTS VALUE',
            valor: 'VALUE',
            continuarPago: 'CONTINUE TO CHECKOUT',
            agregarMas: 'Add more items',
            enviandoCocina: '⏳ SENDING...',
            mensajeCocina: 'Once sent, your order goes straight to the kitchen 🍳',
            datosPedido: 'Order Details 📝',
            validarWhatsapp: 'Validate WhatsApp 📱',
            delivery: 'Delivery',
            retiroLocal: 'Pick Up',
            nombreCompleto: 'Full name',
            telefono: 'Phone (e.g. 9 1234 5678)',
            nota: 'Any notes (No onions, etc.)',
            metodoPago: 'Payment Method',
            resumenCuenta: 'Order Summary',
            valorProductosLabel: 'Products',
            costoEnvio: 'Delivery Fee',
            gratis: 'Free ($0)',
            totalPagar: 'TOTAL TO PAY',
            procesando: 'PROCESSING...',
            validarCodigo: 'VALIDATE CODE',
            enviarPedido: 'PLACE ORDER FOR',
            cerrar: 'Close',
            pedidoCancelado: 'ORDER CANCELLED',
            canceladoMsg: 'Sorry, the store has cancelled your order.',
            stockMsg: 'This may be due to stock or delivery range.',
            entendidoVolver: 'OK, BACK TO MENU',
            hacerNuevoPedido: '✨ PLACE NEW ORDER',
            cerrarVerMenu: 'CLOSE AND VIEW MENU',
            tuPedido: 'YOUR ORDER',
            total: 'TOTAL',
            verDetalle: '🛒 VIEW ORDER DETAILS',
            ocultarDetalle: '🛒 HIDE DETAILS',
            cargandoMapa: 'Loading map...',
            fueraDeRango: '❌ Sorry, this location is outside our delivery zone.',
            verificado: '✅ Verified',
            tocar: 'Tap the',
            paraVerificar: 'to verify',
            esperandoSms: '📱 SMS Validation',
            enviarSms: '📨 SEND SMS CODE',
            enviandoSms: 'SENDING...',
            codigoValido: 'Code valid for 5 minutes',
        },
    },
    pt: {
        nav: {
            inicio: 'Início', vender: 'Vender', mesas: 'Mesas', pedidos: 'Pedidos',
            inventario: 'Estoque', menu: 'Cardápio', cartaQr: 'Menu QR',
            reportes: 'Relatórios', ajustes: 'Configurações',
        },
        usuario: {
            cambiarPassword: 'Alterar senha', cerrarSesion: 'Sair',
            verOtrosPlanes: 'Ver outros planos', confirmarSalir: 'Tem certeza que deseja sair?',
        },
        carta: {
            cargando: 'Carregando cardápio...',
            todos: 'Todos',
            verCarrito: 'VER CARRINHO',
            enviarCocina: 'ENVIAR À COZINHA',
            tuSeleccion: 'Sua Seleção',
            tuPedidoMesa: 'Seu Pedido na Mesa',
            cantidad: 'Quantidade',
            personalizacion: 'Personalização',
            valorProductos: 'VALOR DOS ITENS',
            valor: 'VALOR',
            continuarPago: 'CONTINUAR PARA O PAGAMENTO',
            agregarMas: 'Adicionar mais itens',
            enviandoCocina: '⏳ ENVIANDO...',
            mensajeCocina: 'Ao enviar, seu pedido vai direto para a cozinha 🍳',
            datosPedido: 'Dados do Pedido 📝',
            validarWhatsapp: 'Validar WhatsApp 📱',
            delivery: 'Entrega',
            retiroLocal: 'Retirada',
            nombreCompleto: 'Nome completo',
            telefono: 'Telefone (Ex: 9 1234 5678)',
            nota: 'Alguma observação (Sem cebola, etc.)',
            metodoPago: 'Forma de Pagamento',
            resumenCuenta: 'Resumo do Pedido',
            valorProductosLabel: 'Valor dos Itens',
            costoEnvio: 'Taxa de Entrega',
            gratis: 'Grátis ($0)',
            totalPagar: 'TOTAL A PAGAR',
            procesando: 'PROCESSANDO...',
            validarCodigo: 'VALIDAR CÓDIGO',
            enviarPedido: 'FAZER PEDIDO POR',
            cerrar: 'Fechar',
            pedidoCancelado: 'PEDIDO CANCELADO',
            canceladoMsg: 'Lamentamos, o estabelecimento cancelou seu pedido.',
            stockMsg: 'Pode ser por falta de estoque ou fora da área de entrega.',
            entendidoVolver: 'OK, VOLTAR AO CARDÁPIO',
            hacerNuevoPedido: '✨ FAZER NOVO PEDIDO',
            cerrarVerMenu: 'FECHAR E VER CARDÁPIO',
            tuPedido: 'SEU PEDIDO',
            total: 'TOTAL',
            verDetalle: '🛒 VER DETALHES DO PEDIDO',
            ocultarDetalle: '🛒 OCULTAR DETALHES',
            cargandoMapa: 'Carregando mapa...',
            fueraDeRango: '❌ Desculpe, este endereço está fora da nossa área de entrega.',
            verificado: '✅ Verificado',
            tocar: 'Toque o',
            paraVerificar: 'para verificar',
            esperandoSms: '📱 Validação por SMS',
            enviarSms: '📨 ENVIAR CÓDIGO SMS',
            enviandoSms: 'ENVIANDO...',
            codigoValido: 'Código válido por 5 minutos',
        },
    },
};

const IdiomaContext = createContext();

export function IdiomaProvider({ children }) {
    const [idioma, setIdioma] = useState(localStorage.getItem('idioma') || 'es');

    function cambiarIdioma(lng) {
        setIdioma(lng);
        localStorage.setItem('idioma', lng);
    }

    function t(seccion, clave) {
        return (traducciones[idioma] && traducciones[idioma][seccion] && traducciones[idioma][seccion][clave])
            || (traducciones['es'][seccion] && traducciones['es'][seccion][clave])
            || clave;
    }

    return (
        <IdiomaContext.Provider value={{ idioma, cambiarIdioma, t }}>
            {children}
        </IdiomaContext.Provider>
    );
}

export function useIdioma() {
    return useContext(IdiomaContext);
}
